var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.photos),function(photo,index){return _c('v-col',{key:`photo_${photo.id}`,attrs:{"cols":"auto"}},[_c('UIMediaPhoto',{attrs:{"value":photo},on:{"click":function($event){return _vm.showPhoto(index)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }